import src from "IMAGE";
export default { src, width: 162, height: 32, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ADg9SY8zNkGFMzdCgTY5RYUxNT+AKCszWSgrNFUrLjdaABcZHjIiJSxQJScvUyEjKUQPEBQkDg8SHg4PEhsMDQ8WAH0MmxyLaRoAAAAASUVORK5CYII="};
